import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhysicalProductComponent } from './physical-product.component';
import { ProductStepOneComponent } from './components/product-step-one/product-step-one.component';
import { ProductStepTwoComponent } from './components/product-step-two/product-step-two.component';
import { ProductStepThreeComponent } from './components/product-step-three/product-step-three.component';
import { Ng2ImgMaxModule } from 'ng2-img-max';

const physicalProductRoutes: Routes = [
  { path: '', component: PhysicalProductComponent },
  { path: 'edit/:id', component: PhysicalProductComponent },
];

@NgModule({
  declarations: [
    PhysicalProductComponent,
    ProductStepOneComponent,
    ProductStepTwoComponent,
    ProductStepThreeComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(physicalProductRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    Ng2ImgMaxModule
  ],
  providers: []
})

export class PhysicalProductModule { }
